import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useProductGiftRecommended() {
  const { data } = useQuery(queries.recommendedItems.gift('PRODUCT'));
  return data;
}

export default useProductGiftRecommended;
